import { ReactNode } from 'react'
import classNames from 'classnames'

import { useProject } from '../project/hook'
import { IconButton } from '../buttons/iconButton'
import NextIcon from '../icons/nextIcon'
import PrevIcon from '../icons/prevIcon'
import { Tab } from './tab'
import { usePreviewVisible } from '../preview/usePreviewVisible'
import { getPreviewDisplayMode } from '../preview/previewDisplayMode'
import './tabBar.css'

interface TabBarProps {
  children: ReactNode
}

export const TabBar = ({ children }: TabBarProps) => {
  const { canEdit, missionManager, missionInfo } = useProject()
  // プレビューが実際に表示されるとき（ミッション情報取得前の hidden を除く）だけ、
  // おためしプレイ窓（右上）を避けてサムネイルを左上へ寄せる。editor のマウント条件
  // （previewVisible && displayMode !== 'hidden'）と揃え、表示形態と乖離させない。
  const previewVisible = usePreviewVisible()
  const previewDisplayMode = getPreviewDisplayMode(missionInfo)
  const previewActuallyShown = previewVisible && previewDisplayMode !== 'hidden'

  return (
    <div
      className={classNames('tab-bar', {
        // The toolbox is hidden when the user can't edit the project.
        'tab-bar-no-toolbox': !canEdit,
      })}
    >
      {canEdit && <div className="tab-bar-left-border" />}
      <div className="tab-bar-region">
        <IconButton onClick={missionManager.prevObject.bind(missionManager)}>
          <PrevIcon />
        </IconButton>
      </div>
      <div className="tab-bar-region tab-bar-scrollable">
        {missionManager.objects.map((obj) => (
          <Tab
            key={obj.name}
            label={obj.name}
            onClick={() => {
              missionManager.current = obj.name
            }}
            selected={obj.name === missionManager.current?.name}
            thumbnail={obj.thumbnail}
          />
        ))}
      </div>
      <div className="tab-bar-region">
        <IconButton onClick={missionManager.nextObject.bind(missionManager)}>
          <NextIcon />
        </IconButton>
        {children}
      </div>
      {missionManager.current?.thumbnail && (
        <img
          src={missionManager.current.thumbnail}
          alt={missionManager.current.name}
          className={classNames('tab-bar-thumbnail', {
            'tab-bar-thumbnail-preview-active': previewActuallyShown,
          })}
        />
      )}
    </div>
  )
}
